module.exports = __webpack_public_path__ + "static/media/about.e7fb18aa.PNG";